/* eslint-disable react/jsx-props-no-spreading */
import { Tabs, Tab } from '@mui/material';
import propTypes from 'prop-types';
import classes from './PrimaryTabs.module.css';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
export const PrimaryTabs = ({
  tabIndex, onTabChange, tabList, sx = {},
}) => (
  <Tabs
    sx={{
      width: '100%',
      borderBottom: '1PX solid #ccc',
      position: 'sticky',
      top: '106PX',
      background: '#fff',
      zIndex: '2',
      textTransform: 'none',
      '& .MuiTabs-indicator': {
        display: 'flex',
        backgroundColor: '#645AFF',
        width: '4px',
        left: 0,
        marginTop: '9px',
      },
      '& .MuiTab-root': {
        textTransform: 'none',
        padding: '8PX 16PX',
        '&.Mui-selected': {
          color: '#645AFF',
        },
      },
      ...sx,
    }}
    value={tabIndex}
    onChange={onTabChange}
  >
    {tabList?.map((tab, index) => (
      <Tab
        key={tab.code}
        label={(
          <div className={classes.tab_item}>
            {tab.name}
          </div>
        )}
        {...a11yProps(index)}
      />
    ))}
  </Tabs>
);

PrimaryTabs.propTypes = {
  tabIndex: propTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  tabList: propTypes.array.isRequired,
  onTabChange: propTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  sx: propTypes.object,
};
